module.exports = __webpack_public_path__ + "static/media/title-widget.09862873.svg";